import { notification } from "antd";
import { createEffect, createEvent, createStore, sample } from "effector";
import { NotificationsService } from "../services/root.service";
import { INotification } from "../ts";

const notificationsService = new NotificationsService();

const setNotificationsEvent = createEvent();
export const $notifications = createStore<INotification[]>([]).on(setNotificationsEvent, (_s, p) => p);

export const fetchNotificationsFx = createEffect(async () => {
    try {
        const res = await notificationsService.getAll();
        return res;
    } catch (err) {
        return { error: err }
    }
});

export const readAllNotificationsFx = createEffect(async () => {
    try {
        const res = await notificationsService.markAllAsReaden();
        return res;
    } catch (err) {
        //return { error: err }
        notification.warning({ message: err as string });
    }
});



sample({
    target: setNotificationsEvent,
    clock: fetchNotificationsFx.doneData,
});

